import Cookies from 'js-cookie';
import { useCallback, useEffect, useState } from 'react';

const APPLE_PAY_PROVISIONING_TIPS_CARD_NAME = 'apple_pay_provision_tips_card';
const HUNDRED_AND_EIGHTY_DAYS = 180;

const useTipsCardCookies = (): [boolean, () => void] => {
    const [showTipsCards, setShowTipsCards] = useState(false);
    useEffect(() => {
        const tipCardName = Cookies.get(APPLE_PAY_PROVISIONING_TIPS_CARD_NAME);
        setShowTipsCards(!tipCardName);
    }, [setShowTipsCards]);

    const closeTipsCard = useCallback(() => {
        Cookies.set(APPLE_PAY_PROVISIONING_TIPS_CARD_NAME, 'closed', { expires: HUNDRED_AND_EIGHTY_DAYS });
        setShowTipsCards(false);
    }, []);

    return [showTipsCards, closeTipsCard];
};

export default useTipsCardCookies;
